export * from './AddCard';

import AddCard from './AddCard';
export default AddCard;
